import { Route, Switch } from 'react-router-dom';

import {
  AccountActivationPage,
  ChannelVerifiedPage,
  MagicLinkLandingPage,
  PasswordRecoveryPage,
  PasswordResetPage,
} from '@identity/presentation/pages';

/**
 * Public routes of the `identity` domain: the magic link landing, the activation wizard, the channel
 * confirmation and the two halves of the recovery flow.
 *
 * The private route of the domain, `/verify-account`, is **not** here: it authorizes with the Parrot
 * session, and keeping the two credentials in separate route tables is what makes the entry point of
 * each flow unambiguous.
 *
 * Every route is `exact`, which is what lets the recovery request and the reset share a prefix
 * without the request swallowing the reset as a path with something left over.
 */
export const AuthRoutes = () => {
  return (
    <Switch>
      <Route component={AccountActivationPage} exact path="/auth/activate" />
      <Route component={MagicLinkLandingPage} exact path="/auth/link" />
      <Route component={PasswordRecoveryPage} exact path="/auth/recover" />
      <Route component={PasswordResetPage} exact path="/auth/recover/reset" />
      <Route component={ChannelVerifiedPage} exact path="/auth/verified/:channel" />
    </Switch>
  );
};
